import React, { useEffect, useReducer } from 'react';
import { Switch, Route, useParams, useRouteMatch, NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Card, Spinner, Nav, Alert, Col } from 'react-bootstrap';
import { IoIosArrowBack } from "react-icons/io";
import { CSSTransition } from 'react-transition-group';
import { useTranslation } from 'react-i18next';

import api from './../../../api';

import { toastrAdd } from './../../../actions';

import ScanList from './../ScanList/ScanList';
import ScanPointSettingsForm from './ScanPointSettingsForm/ScanPointSettingsForm';

const initialState = {
    scanPoint: {},
    loading: true,
    initialized: false,
    error: false
}

const reducer = (state, action) => {
    switch(action.type) {
        case 'LOADING':
            return {
                ...state,
                loading: action.loading
            }
        case 'FETCH_SCANPOINT':
            return {
                ...state,
                initialized: false,
                loading: true
            }
        case 'FETCH_SCANPOINT_SUCCESS':
            return {
                ...state,
                scanPoint: action.scanPoint,
                loading: false,
                initialized: true,
                error: false
            }
        case 'FETCH_SCANPOINT_FAIL':
            return {
                ...state,
                scanpoint: action.scanPoint,
                loading: false,
                initialized: true,
                error: action.error
            }
        case 'SAVE_SCANPOINT':
            return {
                ...state,
                loading: true,
                error: false
            }
        case 'SAVE_SCANPOINT_SUCCESS':
            return {
                ...state,
                scanPoint: action.scanPoint,
                loading: false,
                error: false
            }
        case 'SAVE_SCANPOINT_FAIL':
            return {
                ...state,
                scanPoint: {},
                loading: false,
                error: action.error
            }
        default:
            return state;
    }
}

function ScanPoint(props) {

    const { scanPointID } = useParams();
    const dispatch = useDispatch();
    let { url } = useRouteMatch();
    const { eventID } = props;
    const [ state, stateDispatch ] = useReducer(reducer, initialState);
    const { initialized, loading, scanPoint, error } = state;
    const { t } = useTranslation();

    /**
     * Fetch scan point.
     *
     * @param {string} scanPointID
     */
    const _fetchScanPoint = (scanPointID)  => {
        stateDispatch({type: 'FETCH_SCANPOINT'});
        api.scanpoint.getScanPoint(scanPointID).then(response => {
            stateDispatch({type: 'FETCH_SCANPOINT_SUCCESS', scanPoint: response.data.data.scanPoint });
        }).catch(error => {
            stateDispatch({type: 'FETCH_SCANPOINT_FAIL', error: error.firstError });
        })
    }

    /**
     * Save scan point.
     *
     * @param {object} data
     */
    const _saveScanPoint = data => {
        stateDispatch({type: 'SAVE_SCANPOINT'});
        api.scanpoint.saveScanPoint(data).then(response => {
            stateDispatch({type: 'SAVE_SCANPOINT_SUCCESS', scanPoint: response.data.data.scanPoint});
            dispatch(toastrAdd({code: 0, details: `${data.name} ${t('scan_points.save_success_details')}`, title: t('scan_points.save_success_title'), type: 'success'}));
        })
        .catch(error => {
            stateDispatch({type: 'SAVE_SCANPOINT_FAIL', error: error.firstError});
            dispatch(toastrAdd({
                code: 0,
                type: 'error',
                title: t('scan_points.save_fail_title'),
                details: `${t('general.details')}: ${error.firstError.title} - ${error.firstError.details}`
            }));
        })
    }

    /**
     * Fetch scan point on component mount.
     */
    useEffect(() => {
        if(scanPointID && eventID) {
            _fetchScanPoint(scanPointID)
        }
    }, [scanPointID, eventID])


    return (
        <React.Fragment>

            <div className="row">
                <div className="col-12">
                    <NavLink to={`/events/${eventID}/scanpoints`} style={{position: 'relative', top: '-10px', background: 'white', padding: '6px 15px' }}>
                        <IoIosArrowBack /> {t('scan_points.back_to_scan_points')}
                    </NavLink>
                </div>
                <div className="col text-right">
                    {!initialized &&
                        <Spinner animation="border" role="status" variant="primary">
                            <span className="sr-only">{t('general.loading')}</span>
                        </Spinner>
                    }
                </div>
            </div>

            {error &&
                <Alert variant="danger" style={{marginTop: '20px'}}>
                    <strong>{error.title}</strong><br />
                    <span>{error.details}</span>
                </Alert>
            }

            <CSSTransition
                in={(initialized && !error)}
                timeout={800}
                classNames="FadeIn"
                unmountOnExit
            >
                <Card>
                    <Card.Header className="border-bottom">
                        {scanPoint.name}
                        {loading ?
                            <Spinner animation="border" role="status" variant="primary" size="sm" className="float-right">
                                <span className="sr-only">{t('general.loading')}</span>
                            </Spinner>
                        : null}
                        <Nav variant="tabs">
                            <Nav.Item>
                                <NavLink to={`${url}`} strict exact className="nav-link">{t('scan_points.scan_count')} <span className="light-gray">( {scanPoint.scanCount} )</span></NavLink>
                            </Nav.Item>
                            <Nav.Item>
                        <NavLink to={`${url}/settings`} className="nav-link">{t('scan_points.scan_point_settings')}</NavLink>
                            </Nav.Item>
                        </Nav>
                    </Card.Header>

                    <Switch>
                        <Route exact path={`${url}`}>
                            <ScanList
                                scanPointID={scanPointID}
                                loading={loading}
                                eventID={eventID}
                            />
                        </Route>
                        <Route exact path={`${url}/settings`}>
                            <Card.Body>
                                <Col lg={8}>
                                    <ScanPointSettingsForm
                                        scanPoint={scanPoint}
                                        handleScanPointSave={_saveScanPoint}
                                        loading={loading}
                                    />
                                </Col>

                            </Card.Body>
                        </Route>
                    </Switch>

                </Card>
            </CSSTransition>

        </React.Fragment>
    )
}

export default ScanPoint;